import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'hc-hygiene-check',
  templateUrl: './hygiene-check.component.html',
  styleUrls: ['./hygiene-check.component.css']
})
export class HygieneCheckComponent implements OnInit {

  constructor(private router: Router) { }
  
    ngOnInit() {
    }
  
    onChildData(event :any){
      this.router.navigate([event]);
      }
}
